import { c as _c } from "react/compiler-runtime";
import FooterTopBar from "./FooterTopBar";
import FooterMiddle from "./FooterMiddle";
import FooterBottomBar from "./FooterBottomBar";
const FOOTER_BG = "linear-gradient(180deg, #001119 0%, #0D0D1B 100%)";
export default function Footer() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <footer className="relative w-full text-white pb-18 md:pb-0 mt-6 z-50" style={{
      background: FOOTER_BG
    }}><FooterTopBar /><FooterMiddle /><FooterBottomBar /></footer>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}